import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Chip,
  Box,
} from '@mui/material'
import { maskCurrency } from '../../../../utils/maskUtils'

const InfoItem = ({ label, value, color = 'text.primary' }) => (
  <Box mb={2}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h6" color={color} fontWeight={600}>
      {maskCurrency(value)}
    </Typography>
  </Box>
)

const ContractInfoCard = ({ contractInfo }) => {
  if (!contractInfo) return null

  const { anual, mensal } = contractInfo
  const annualServices = anual.servicos || {}
  const monthlyServices = mensal.servicos || {}
  const annualEquipmentTotal = Number(anual.valor_total) || 0
  const annualServicesTotal = Number(annualServices.valor_total) || 0
  const monthlyEquipmentTotal = Number(mensal.valor_total_mensal) || 0
  const monthlyServicesTotal = Number(monthlyServices.valor_total_mensal) || 0

  return (
    <Card elevation={3} sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          Informações do Contrato
        </Typography>

        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={4}>
          {/* Anual */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              color="primary"
              gutterBottom>
              Saldo Anual
            </Typography>

            <InfoItem
              label="Valor Total Anual (Equipamentos + Serviços)"
              value={annualEquipmentTotal + annualServicesTotal}
            />
            <InfoItem
              label="Total Anual de Equipamentos"
              value={annualEquipmentTotal}
            />

            {anual.servicos && (
              <>
                <InfoItem
                  label="Total Anual de Serviços"
                  value={annualServicesTotal}
                />
                <InfoItem
                  label="Serviços utilizados (faturamentos aprovados)"
                  value={annualServices.valor_utilizado}
                />
                <InfoItem
                  label="Saldo de Serviços"
                  value={annualServices.saldo_disponivel}
                />
              </>
            )}

            <InfoItem label="Valor Utilizado" value={anual.valor_utilizado} />

            <Chip
              color={anual.saldo_disponivel < 0 ? 'error' : 'success'}
              variant="filled"
              label={`Saldo Disponível: ${maskCurrency(
                anual.saldo_disponivel
              )}`}
            />
          </Grid>

          {/* Mensal */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="subtitle1"
              fontWeight={700}
              color="primary"
              gutterBottom>
              Saldo Mensal
            </Typography>

            <InfoItem
              label="Valor Total Mensal (Equipamentos + Serviços)"
              value={monthlyEquipmentTotal + monthlyServicesTotal}
            />
            <InfoItem
              label="Total Mensal de Equipamentos"
              value={monthlyEquipmentTotal}
            />

            {mensal.servicos && (
              <>
                <InfoItem
                  label="Total Mensal de Serviços"
                  value={monthlyServicesTotal}
                />
                <InfoItem
                  label="Serviços utilizados no mês"
                  value={monthlyServices.valor_utilizado_mensal}
                />
                <InfoItem
                  label="Saldo Mensal de Serviços"
                  value={monthlyServices.saldo_disponivel_mensal}
                />
              </>
            )}

            <InfoItem
              label="Valor Utilizado"
              value={mensal.valor_utilizado_mensal}
            />

            <Chip
              color={mensal.saldo_disponivel_mensal < 0 ? 'error' : 'success'}
              variant="filled"
              label={`Saldo Disponível: ${maskCurrency(
                mensal.saldo_disponivel_mensal
              )}`}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default ContractInfoCard
